var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"options---horizontal-a","d":"M10,10 L14,10 L14,14 L10,14 L10,10 Z M10,3 L14,3 L14,7 L10,7 L10,3 Z M10,17 L14,17 L14,21 L10,21 L10,17 Z"})),React.createElement("use",{"fillRule":"evenodd","transform":"rotate(90 12 12)","xlinkHref":"#options---horizontal-a","key":1})]);
}

Menu.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Menu;

Menu.default = Menu;
